import { Fragment, memo, useCallback } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import RelativeLink from "app/pages/.shared/RelativeLink";
import { sendTagOnFaqFeaturedArticleClick } from "app/utils/analytics";
import { htmlSanitize } from "app/utils/sanitize";
import "./FaqFeaturedArticle.scss";

const FaqFeaturedArticle = ({
	articleName,
	articleContent,
	articleLink,
	breadcrumb,
	handleClick = () => {},
	target,
}) => {
	const handleArticleClick = useCallback(() => {
		sendTagOnFaqFeaturedArticleClick(articleName);
		handleClick();
	}, [articleName]);

	return (
		<RelativeLink
			to={{ pathname: articleLink }}
			onClick={handleArticleClick}
			{...target && { target }}
		>
			<div className="faq-featured-article">
				<div className="faq-featured-article__breadcrumb">{breadcrumb}</div>
				<div className="faq-featured-article__name">{articleName}</div>
				<div className="faq-featured-article__content">
					{articleContent.map((mes, idx) => (
						<Fragment key={idx}>
							<div
								className="faq-featured-article__line"
								dangerouslySetInnerHTML={{ __html: htmlSanitize(mes) }}
							/>
							<br />
						</Fragment>
					))}
				</div>
				<div className="faq-featured-article__link">
					<FormattedMessage id="faq.home.feature.article.link" />
				</div>
			</div>
		</RelativeLink>
	);
};

FaqFeaturedArticle.propTypes = {
	articleName: PropTypes.string,
	articleContent: PropTypes.array,
	articleLink: PropTypes.string,
	breadcrumb: PropTypes.string,
	handleClick: PropTypes.func,
	target: PropTypes.string,
};

export default memo(FaqFeaturedArticle);
